import type { PlanRemappage } from '@/api/activites';

/** Ce que l'API exige pour appliquer un remappage : une confirmation qui nomme les deux codes. */
export function confirmationRemappage(ancien: string, cible: string): string {
  return `${ancien}>${cible}`;
}

/** Résumé lisible d'une analyse de remappage, affiché avant toute confirmation. */
export function resumeRemappage(plan: PlanRemappage): string {
  if (plan.statut === 'conflit') {
    const details = plan.conflits
      .map((c) => `${c.table} (${c.cle}) ${c.champ} : ${String(c.valeurAncien)} contre ${String(c.valeurCible)}`)
      .join(' ; ');
    return `${plan.message ?? 'Conflit.'} ${details}.`;
  }
  if (plan.statut !== 'applicable') return plan.message ?? 'Remappage impossible.';
  const libelles =
    plan.libellesAbandonnes.length > 0
      ? ' Libellé(s) de collecte non conservé(s) : ' +
        plan.libellesAbandonnes.map((l) => `${l.cle} « ${l.libelle} »`).join(', ') +
        '.'
      : '';
  return (
    `${plan.connaissancesDeplacees} domaine(s) de couple re-pointé(s), ${plan.connaissancesFusionnees} fusionné(s) ; ` +
    `${plan.niveauxDeplaces} durée(s) re-pointée(s), ${plan.niveauxFusionnes} fusionnée(s) ; ` +
    `${plan.metiersTouches.length} fiche(s) aux passerelles à recalculer.${libelles}`
  );
}
